<template>
	<div class="table-op-col-bdr">
		<!-- <div class="title_header">
      开票管理
    </div> -->
		<div style="padding-top: 20px; padding-left: 20px; font-size: 12px;">
			<tr>
				<td><span class="title"><b>发票抬头</b></span></td>
			</tr>
			<table border="0" width="100%" style="border-spacing: 0px 20px">
				<tr>
					<td colspan="2"><span class="title1">纳税人名称：</span><b>{{partaCustomerName}}</b></td>
					<td colspan="2"><span class="title1">纳税人识别号：</span><b>{{taxNo}}</b></td>
				</tr>
				<tr>
					<td colspan="2"><span class="title1">注册地址：</span><b>{{registerAddr}}</b></td>
					<td colspan="2"><span class="title1">注册电话：</span><b>{{registerPhone}}</b></td>
				</tr>
				<tr>
					<td colspan="2"><span class="title1">开户银行：</span><b>{{openBankName}}</b></td>
					<td colspan="2"><span class="title1">银行账号：</span><b>{{openBankAccount}}</b></td>
				</tr>
			</table>
			<div style="border-bottom: #EBEEF5 1px solid; margin-bottom: 20px; margin-top: 20px;">
			</div>
			<table border="0" width="100%" style="border-spacing: 0px 20px">
				<tr>
					<td><span class="title"><b>发票寄送</b></span></td>
				</tr>
				<tr>
					<td width="120px">
						收件人姓名：
					</td>
					<td>
						<el-input v-model="invoiceReceiver" :disabled="formDisabled" size="mini" style="width: 350px;" placeholder="收件人姓名"></el-input>
					</td>
					<td width="120px">
						收件人电话：
					</td>
					<td>
						<el-input v-model="invoiceReceiverPhone" :disabled="formDisabled" size="mini" style="width: 350px;" placeholder="收件人电话"></el-input>
					</td>
				</tr>
				<tr>
					<td>
						邮箱：
					</td>
					<td>
						<el-input v-model="invoiceReceiverEmail" :disabled="formDisabled" size="mini" style="width: 350px;" placeholder="请输入邮箱"></el-input>
					</td>
					<td>
						发票寄送地址：
					</td>
					<td>
						<el-input v-model="invoiceSendAddr" :disabled="formDisabled" size="mini" style="width: 350px;" placeholder="发票寄送地址"></el-input>
					</td>
				</tr>

				<tr>
					<td>

					</td>
					<td>

					</td>
					<td>

					</td>
					<td align="center">
						<el-button v-if="permissions.BillingManagerUpdate" v-track="{ action: 'billingManage_editSave' }" type="primary" size="mini" @click="saveOrEditClick">{{saveOrEdit}}</el-button>
						<el-button type="primary" size="mini" @click="cancel()" v-if="saveOrEdit == '保存'">取消</el-button>
					</td>
					<td colspan="4" align="left">

					</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
	import fetchPost from "@/api/http.js";
  import getCheckMobileReg from '@/common/js/checkMobileReg.js';

	export default {
		data() {
			return {
				permissions: {
					BillingManagerUpdate: false  //编辑
				},
				formDisabled: true,
				saveOrEdit: '编辑',
				"id": "",
				"partaCustomerName": "",
				"taxNo": "",
				"registerAddr": "",
				"registerPhone": "",
				"openBankName": "",
				"openBankAccount": "",
				"invoiceReceiver": "",
				"invoiceReceiverPhone": "",
				"invoiceReceiverEmail": "",
				"invoiceSendAddr": ""
			}
		},
		watch:{
			
		},
		mounted() {
			this.queryInvoiceInfo();
      getCheckMobileReg().then((reg) => {
        this.checkMobileReg = reg;
      });
		},
		created() {
			this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
		},
		methods: {
			tipsboxShow() {
				this.dialogTableVisible = true
				this.recharge()
			},
			queryInvoiceInfo() {
				fetchPost("/saas/invoice/queryInvoiceInfo", {}).then(res => {
					this.id = res.id;
					this.partaCustomerName = res.partaCustomerName;
					this.taxNo = res.taxNo;
					this.registerAddr = res.registerAddr;
					this.registerPhone = res.registerPhone;
					this.openBankName = res.openBankName;
					this.openBankAccount = res.openBankAccount;
					this.invoiceReceiver = res.invoiceReceiver;
					this.invoiceReceiverPhone = res.invoiceReceiverPhone;
					this.invoiceReceiverEmail = res.invoiceReceiverEmail;
					this.invoiceSendAddr = res.invoiceSendAddr;
				});
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.queryInvoiceInfo();
			},
			saveOrEditClick(){
				if(this.saveOrEdit=='编辑'){
					this.saveOrEdit = '保存';
					this.formDisabled = false;
				}else{
          if (!this.validate()) {
            return false;
          }
					this.saveOrEdit = '编辑';
					this.formDisabled = true;
					this.onSubmit();
				}
			},
			cancel(){
				this.saveOrEdit = '编辑' ;
				this.formDisabled = true;
				this.queryInvoiceInfo();
			},
      validate() {
        if (this.invoiceReceiver == "") {
					this.$message({
						type: 'warning',
						message: '请输入收件人姓名'
					});
					return false;
				}
				if (this.invoiceReceiverPhone == "") {
					this.$message({
						type: 'warning',
						message: '请输入收件人电话'
					});
					return false;
				}

        if (this.checkMobileReg && this.checkMobileReg.test(this.invoiceReceiverPhone)) {
          this.$message({
						type: 'warning',
						message: '请输入正确的手机号'
					});
					return false;
        }

				if (this.invoiceReceiverEmail == "") {
					this.$message({
						type: 'warning',
						message: '请输入邮箱地址'
					});
					return false;
				}
				if (this.invoiceSendAddr == "") {
					this.$message({
						type: 'warning',
						message: '请输入发票寄送地址'
					});
					return false;
				}

        return true;
      },
			onSubmit() {
				fetchPost("/saas/invoice/updateInvoiceInfo", {
					"id": this.id,
					"invoiceReceiver": this.invoiceReceiver,
					"invoiceReceiverPhone": this.invoiceReceiverPhone,
					"invoiceReceiverEmail": this.invoiceReceiverEmail,
					"invoiceSendAddr": this.invoiceSendAddr
				}).then(res => {
					console.log("==="+res)
					if (res == 1) {
						this.$message({
							type: 'success',
							message: '您没有任何改动,无法保存'
						});
						return;
					}
					if (res == 2) {
						this.$message({
							type: 'success',
							message: '更新成功'
						});
						this.queryInvoiceInfo();
						return;
					}
					if (res == 3) {
						this.$message({
							type: 'success',
							message: '新增成功'
						});
						this.queryInvoiceInfo();
						return;
					}
				});
			}
		}
	}
</script>
<style>
	.title1 {
		color: #909399;
	}

	.title {
		font-size: 16px;
	}
</style>
